import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Cookie } from 'lucide-react';
import axios from 'axios';
import DOMPurify from 'dompurify';

const API = process.env.REACT_APP_BACKEND_URL + '/api';

/**
 * CookiesPage - Displays the cookie policy
 */
const CookiesPage = () => {
  const [content, setContent] = useState('<p>Cookiebeleid wordt geladen...</p>');
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const loadPolicy = async () => {
      try {
        const response = await axios.get(`${API}/gdpr/cookies`);
        setContent(response.data.content);
      } catch (error) {
        console.error('Failed to load cookie policy:', error);
        setContent('<p>Kon het cookiebeleid niet laden. Probeer het later opnieuw.</p>');
      } finally {
        setIsLoading(false);
      }
    };
    loadPolicy();
  }, []);

  return (
    <div className="min-h-screen bg-[#F5F0E8]">
      {/* Header */}
      <div className="bg-[#1C1C2E] py-8">
        <div className="max-w-4xl mx-auto px-4">
          <Link 
            to="/" 
            className="inline-flex items-center gap-2 text-gray-300 hover:text-white mb-4 transition-colors"
          >
            <ArrowLeft className="w-4 h-4" />
            Terug naar home
          </Link>
          <div className="flex items-center gap-4">
            <Cookie className="w-10 h-10 text-[#C8963E]" />
            <h1 className="text-3xl font-serif font-bold text-white">Cookiebeleid</h1>
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-4xl mx-auto px-4 py-12">
        <div className="bg-white rounded-2xl shadow-lg p-8 md:p-12">
          {isLoading ? (
            <div className="flex items-center justify-center py-12">
              <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-[#C8963E]"></div>
            </div>
          ) : (
            <div 
              className="prose prose-lg max-w-none
                prose-headings:font-serif prose-headings:text-[#1C1C2E]
                prose-h2:text-2xl prose-h2:mt-8 prose-h2:mb-4 prose-h2:border-b prose-h2:border-[#C8963E] prose-h2:pb-2
                prose-h3:text-xl prose-h3:mt-6 prose-h3:mb-3
                prose-h4:text-lg prose-h4:mt-4 prose-h4:mb-2
                prose-p:text-[#2C2C3E] prose-p:leading-relaxed
                prose-li:text-[#2C2C3E]
                prose-ul:my-4
                prose-a:text-[#C8963E] prose-a:no-underline hover:prose-a:underline
                prose-strong:text-[#1C1C2E]"
              dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(content) }}
              data-testid="cookies-content"
            />
          )}
        </div>

        {/* Manage cookies button */}
        <div className="mt-8 text-center">
          <button 
            onClick={() => window.openCookieSettings?.()}
            className="inline-flex items-center gap-2 bg-[#C8963E] text-white px-6 py-3 rounded-lg font-semibold hover:bg-[#B8862E] transition-colors"
            data-testid="manage-cookies-btn"
          >
            <Cookie className="w-5 h-5" />
            Cookie-instellingen wijzigen
          </button>
        </div>

        {/* Footer links */}
        <div className="mt-8 text-center text-sm text-gray-500">
          <Link to="/privacy" className="text-[#C8963E] hover:underline">Privacybeleid</Link>
        </div>
      </div>
    </div>
  );
};

export default CookiesPage;
